import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import type { NavigationScreenSpaceState } from '@gitbook/app-navigation';
import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps } from '@gitbook/spine-react';

/**
 * Button to open the discussion sidesheet.
 */
export function CommentsSideSheetButton(
    props: {
        space: api.Space;
        changeRequest: api.ChangeRequest | null;
        screen: NavigationScreenSpaceState;
    } & Omit<ButtonProps, 'onPress' | 'label'>
): React.ReactElement {
    const { space, changeRequest, screen, style, ...rest } = props;

    const count = changeRequest ? changeRequest.comments : space.comments;

    const showingAllComments =
        screen.sideSheet?.type === 'comments' && screen.sideSheet?.context !== 'preview';

    return (
        <Button
            {...rest}
            href={{
                screen: {
                    sideSheet: showingAllComments ? undefined : { type: 'comments' },
                },
            }}
            active={showingAllComments}
            leadingIcon={Icon.Comment}
            iconOnly={!count}
            style={style}
            label={`${count ? count : 'Comments'}`}
        />
    );
}
